import React, { useEffect, useState } from 'react'
import { AudioWrapper, Icon, Label, VolumeOn } from './AudioStyle'
import { ReactComponent as VolumeSVG } from '../../../lib/assets/volume.svg'
import { ReactComponent as LowSVG } from '../../../lib/assets/volumeLow.svg'
import { ReactComponent as HighSVG } from '../../../lib/assets/volumeHigh.svg'
import { ReactComponent as OffSVG } from '../../../lib/assets/volumeOff.svg'
import VolumeBar from './Volume'
interface AudioProps {
  title: string
  volume: string
  setVolume: any
  mute: boolean
  setMute: any
  socketValue: any
  focusHandler: any
}
export default function AudioComponent({
  title,
  volume,
  setVolume,
  mute,
  setMute,
  socketValue,
  focusHandler,
}: AudioProps) {
  const vol = Number(volume)
  const [focus, setFocus] = useState<boolean>(false)
  const [isFirstRun, setFirstRun] = useState(true)

  const handleMute = () => {
    mute ? setMute(false) : setMute(true)
    setFocus(true)
    setFirstRun(false)
  }
  useEffect(() => {
    !isFirstRun && focusHandler(focus)
  }, [focus])

  return (
    <AudioWrapper music={title === 'music'}>
      <Label>{title}</Label>
      <VolumeBar
        title={title}
        setVolume={setVolume}
        volume={volume}
        mute={mute}
        setMute={setMute}
        socketValue={socketValue}
        focusHandler={focusHandler}
      />
      <Icon
        music={title === 'music'}
        onMouseDown={() => handleMute()}
        onMouseUp={() => setFocus(false)}
      >
        <VolumeSVG />
        {mute || volume === '0' ? (
          <OffSVG className='off' />
        ) : (
          <VolumeOn>
            <LowSVG /> {vol >= 50 && <HighSVG />}
          </VolumeOn>
        )}
      </Icon>
    </AudioWrapper>
  )
}
